// LIBRARIES
// LIBRARIES
import styled from "styled-components";

// MISC
import { DEVICE_TYPE, FONT_SIZE, SIZE } from "constants/variables";

// MISC

export const Title = styled.h6`
  font-size: ${FONT_SIZE.max24};
  color: #333;
  align-self: center;
  margin-bottom: 5px;
`;

export const PreloaderWrapper = styled.div`
  position: absolute;
  z-index: 1000;
  background-color: rgba(29, 29, 38, 0.75);
  width: 100%;
  height: 100dvh;
  display: flex;
  align-items: center;
  justify-content: center;
  top: 0;
  left: 0;
`;

export const MapContainer = styled.div`
  display: flex;
  width: 100%;
  height: 100dvh;
  position: relative;
`;

export const InterestPointsMenu = styled.ul`
  list-style: none;
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  align-items: flex-start;
  position: absolute;
  top: 14% !important;
  height: 8em;
  width: auto;
  @media (min-width: ${DEVICE_TYPE.fullHd}) {
    padding: 0 ${SIZE.max500};
  }
  text-transform: capitalize;
  font-size: 0.8em;
  font-weight: bold;
  flex-wrap: wrap;
  z-index: 50;
  gap: ${SIZE.max12};
  padding: 0 ${SIZE.max320};
`;
